/** Shared footer clearance for a floating workspace launcher. Narrow detail
 * columns keep the action group left and leave vertical room below it. */
export const EXPANDED_EDITOR_FOOTER =
  "mt-auto flex flex-wrap items-center gap-3 border-t border-pb-border pt-4 pb-16 @min-[36rem]:pb-0 @min-[36rem]:pe-48";
export const EXPANDED_EDITOR_ACTIONS =
  "flex shrink-0 gap-2 @min-[36rem]:ms-auto";
